<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="solution">
        <div class="breadCrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/newsCenter' }">新闻中心</el-breadcrumb-item>
            <el-breadcrumb-item>公司新闻</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content">
          <div class="title">
            <p>荣誉丨功存智能获得CMMI三级证书</p>
            <span>2020.08.31</span>
          </div>
          <div class="detail">
            <p>2020年8月31日，在上海功存智能科技有限公司会议室举行的CMMI3级认证结果发布会上，评估师宋骏老师向公司高层及参与评审的项目组成员郑重宣布：经过严格的现场审核和评估，
              上海功存智能科技有限公司已经达成了CMMI L3级目标，成功通过CMMI3级认证!</p>
            <div class="picImg"><img src="../../../public/newsImg/honor.png" alt=""></div>
            <p>CMMI全称是Capability Maturity Model Integration, 即软件能力成熟度模型集成，是由美国国防部与卡内基-梅隆大学和美国国防工业协会共同开发和研制的，其目的是帮助软件企业对
              软件工程过程进行管理和改进，增强开发与改进能力，从而能按计划开发出高质量的软件。通过CMMI3级评估是我公司过程改进工作的一个重要的里程碑，标志着公司在软件设计、开发
              、项目管理及为用户提供高质量产品方面达到一个新的水平。CMMI是一个持续改进模型，通过3级认证只是万里长征第一步，在以后的工作中，公司将继续深化改进，规范流程，提升管
              理水平，提高产品质量和工作效率，以实现更高的战略目标!</p>
          </div>
        </div>
        <div class="footNav">
          <ul>
            <li><a href="#/newsCenter/activity">上一篇：活动丨功存智能携手老麦咖啡亮相2020敏捷之旅上海站</a></li>
            <li>下一篇：“暂无”</li>
          </ul>
        </div>
      </div>    
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>
  </el-container>
</template>

<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';

export default {
  components: { navmenu,footerMenu },

  data(){
    return{
      imgList:[
        {
          name: "banner1",
          title:'新闻中心',
          detail:'News Center',
          src: require("../../../public/newsImg/newsbanner.png"),
        },
      ]
    }
  },
  mounted(){
    console.log(this.$route)
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/style/public.scss';

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
    }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
}

  .view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 90px;
    text-align: left;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: none;
        margin-left: 5px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          padding-bottom: 20px;
          // width: 326px;
        }
      }
    }
  }


.solution{
  height:1208px;
  .breadCrumb{
    height: 67px;
    border-bottom: 1px solid #ccc;
  }
  .content{
    height: 950px;
    p{
      font-size: 16px;
      line-height: 32px;
    }
    .title{
      height: 33px;
      padding-top: 60px;
      p{
        font-size: 26px;
        font-weight: bold;
      }
      
    }
    .detail{
      text-align: left;
      padding-top: 64px;
      .picImg{
        width: 561px;
        height: 426px;
        margin: 0 auto;
      }
    }
  }
  .footNav{
    ul{
      height: 128px;
      line-height: 128px;
      font-size: 16px;
      color: #fff;
      display: flex;
      justify-content: space-around;
    }
    li:hover{
      cursor: pointer;
      height: 148px;
    }
    li{
      a{
        color: #fff;
      }
      width: 50%;
      height: 100%;      
    }
    li:first-child{
      background: url("../../../public/newsImg/libg_1.png ");
    }
    li:last-child{
      background: url("../../../public/newsImg/libg_2.png ");
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/newsCenter/honor.vue